import { toast } from 'react-toastify';
import { postApiCall } from '../Handlers/HttpHandler';

/**
 * Fetches the list of games for a single confirmed provider.
 * @param {string} token
 * @param {number} aggregatorId
 * @param {number} providerId
 * @param {string} apiProviderName - confirmed API-side provider name (from ProviderPairSelector)
 * @param {number[]} casinoIds
 */
export const getGameList = async (token, aggregatorId, providerId, apiProviderName, casinoIds = []) => {
   try {
     const result = await postApiCall(
       'game-list',
      { aggregatorId, providerId, apiProviderName, casinoIds },
       token
     );

     if (result.error) {
       toast.error(result.error?.message ?? result.error);
       return null;
     }

     return result.data ?? [];
   } catch (ex) {
     toast.error('Failed to load games');
     return null;
   }
 };

/**
 * Imports game configs for a specific casino operator.
 * @param {string} token
 * @param {{ aggregatorId: number, providerId: number, apiProviderName: string, gameCodes: string[] }} payload
 */
export const importOperatorGameConfigs = async (token, payload) => {
  try {
    const result = await postApiCall('import-operator-game-configs', payload, token);

    if (result.error) {
      toast.error(result.error?.message ?? result.error);
      return null;
    }

    return result.data;
  } catch (ex) {
    toast.error('Operator import failed');
    return null;
  }
};

/**
 * Imports game configs globally (all casinos).
 * @param {string} token
 * @param {{ aggregatorId: number, providerId: number, gameCodes: string[] }} payload
 */
export const importGameConfigs = async (token, payload) => {
  try {
    const result = await postApiCall('import-game-configs', payload, token);

    if (result.error) {
      toast.error(result.error?.message ?? result.error);
      return null;
    }

    return result.data;
  } catch (ex) {
    toast.error('Global import failed');
    return null;
  }
};
